import { useElplanBids } from 'api/elplan/elplan.api'

type UseHasBidsOutsideSelectedPartitionParams = {
  elplanInfoId?: number
  startTime: ISODateTime
  endTime?: ISODateTime
  selectedPartitionId?: number
}

/**
 * Whether the day holds at least one bid outside the selected partition — the warning that a Send,
 * which dispatches the whole day across every partition, reaches bids the partitioned view hides.
 *
 * Lives beside the Send control rather than inside the bid editor: a Send is day-wide, and the
 * editor renders below the scenario's uiConfig where the notice is off-screen at send time. The
 * day-wide read shares its query key with the editor's own combined-limit read, so React Query
 * serves both from one request.
 */
export function useHasBidsOutsideSelectedPartition({
  elplanInfoId,
  startTime,
  endTime,
  selectedPartitionId,
}: UseHasBidsOutsideSelectedPartitionParams): boolean {
  const isPartitionSelected = selectedPartitionId !== undefined

  const { data: dayWideBids } = useElplanBids(
    elplanInfoId,
    startTime,
    endTime,
    undefined,
    undefined,
    isPartitionSelected
  )

  if (!isPartitionSelected) {
    return false
  }

  return dayWideBids?.some((bid) => bid.partition !== selectedPartitionId) ?? false
}
